<template>
    <div class="plan-medical">
        <div class="notes" v-if="SsoButtonText(healthplanD.provider)">
            <p>Please note, you will be navigating to another site.</p>
            <a
                @click.prevent="ssoClickNew(healthplanD.provider)"
                href="#"
                class="btn btn-primary btn-sb-red mt-2"
            >
                {{ SsoButtonText(healthplanD.provider) }}
            </a>
            <a
                v-if="false && elig.memberdata['sso_flag'].includes('5') && ['UMR', 'UHC'].includes(healthplanD.provider) && showbtns"
                @click.prevent="ssoClickNew(['UMR', 'UHC'].find(value => value !== healthplanD.provider))"
                href="#"
                class="btn btn-primary btn-sb-red mt-2"
            >
                {{ SsoButtonText(['UMR', 'UHC'].find(value => value !== healthplanD.provider)) }}
            </a>

        </div>
        <div class="row mt-12">
            <div v-if="field && field.fieldgroup !== 'contact' && field.fieldtype === 'heading2'" class="col-lg-8">
                <div class="card border-0">
                    <div class="card-header">
                        <span>{{ field.label }}</span>
                    </div>
                    <div class="card-body gray-bg">
                        <ul class="list-group">
                            <div v-if="field.children.length > 0"
                                 v-for="subfield in field.children"
                            >
                                <template v-if="!blockedFields.includes(subfield.label)">
                                    <li v-if="subfield.fieldtype === 'heading3'"
                                        class="list-group-item border-top-0 border-bottom-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 pt-2 mr-2"
                                    >
                                        <div class="row">
                                            <div class="col-md-12 sb-benefit-main-list-title pl-4 text-uppercase">
                                                {{ subfield.label }}
                                            </div>
                                        </div>
                                    </li>
                                    <li v-else-if="showSubfield(subfield)"
                                        class="list-group-item border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 pt-2 mr-2"
                                    >
                                        <div class="row">
                                            <div class="col-md-7 sb-benefit-main-list-title pl-4">
                                                {{ subfield.label }}
                                            </div>
                                            <div class="col-md-5 text-right sb-benefit-main-list-value">
                                                {{ subfield.type == 'currency' ? '$' : '' }}{{ subfield.value }}{{ subfield.type === 'percent' ? '%' : '' }}
                                            </div>
                                        </div>
                                    </li>
                                    <li v-if="subfield.children.length > 0"
                                        v-for="(sub,key) in subfield.children"
                                        :class="key+1==subfield.children.length?'list-group-item border-bottom-1 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0':'list-group-item border-bottom-0 border-top-0 border-right-0 border-left-0 ml-0 pt-2 pr-0'"
                                    >
                                        <template v-if="showSub(sub)">
                                            <div class="row  mr-2" v-if="sub.fieldtype === 'heading3'">
                                                <div class="col-md-6 sb-benefit-main-list-title pb-2 text-uppercase">
                                                    {{ sub.value }}
                                                </div>
                                            </div>
                                            <div class="row  mr-0" v-else>
                                                <div class="col-md-8 sb-benefit-main-list-title pl-4">
                                                    {{ sub.label }}
                                                </div>
                                                <div class="col-md-4 text-right sb-benefit-main-list-value">
                                                    {{ sub.type == 'currency' ? '$' : '' }}{{ sub.value }}{{ sub.type === 'percent' ? '%' : '' }}
                                                </div>
                                            </div>
                                            <ul v-for="subsub in sub.children"
                                                class="list-group pr-2" v-if="sub.children.length>0"
                                            >
                                                <li class="list-group-item border-top-0 border-left-0 border-right-0 sb-benefit-sublist-value pt-2 pb-2"
                                                    v-if="subsub.value !== ''"
                                                >
                                                    <div class="row">
                                                        <div class="col-md-8 sb-benefit-main-sublist-title pl-0">
                                                            {{ subsub.label }}
                                                        </div>
                                                        <div class="col-md-4 text-right sb-benefit-main-list-value pr-1">
                                                            {{ subsub.type == 'currency' ? '$' : '' }}{{ subsub.value }}{{ subsub.type === 'percent' ? '%' : '' }}
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </template>
                                    </li>
                                </template>
                            </div>
                            <li v-if="healthplanD.note" class="border-bottom-0 list-group-item card-notes__other border-top-0 border-right-0 border-left-0 ml-1 mr-1 pr-2 pl-2 pb-2 mr-2">
                                <div class="card-notes">
                                    <div class="card-notes-title pt-2">NOTES:</div>
                                    <div class="card-notes-text" v-html="healthplanD.note"></div>
                                </div>
                            </li>
                        </ul>
                        <div class="card-forms">
                            <div class="card-forms-title pt-1">FORMS & BROCHURES</div>
                            <div class="card-forms-link">
                                <a v-for="fb in healthplanD.hpd_fb"
                                   :href="fb.value"
                                   :title="fb.name"
                                   :target="fb.name=='Decrease or Cancel Coverage'?'_self':'_blank'"
                                >{{ fb.name }}</a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-lg-4">
                <div class="card-header">
                    <span>IMPORTANT LINKS</span>
                </div>
                <div class="card-body gray-bg">
                    <div v-if="true">
                        <div v-if="healthplanD.provider === 'UMR'" class="important-link"><a href="#" @click.prevent="ssoClickNew('umr', 'mbrIDCard')" title="ID Cards">ID Cards</a></div>
                        <div v-if="healthplanD.provider === 'UMR'" class="important-link"><a href="#" @click.prevent="ssoClickNew('umr', 'mbrClaims')" title="Claims">Claims</a></div>
                        <div v-if="healthplanD.provider === 'UMR'" class="important-link"><a href="#" @click.prevent="ssoClickNew('umr', 'findaprovider')" title="Provider Search">Provider Search</a></div>
                        <div v-if="healthplanD.provider === 'UMR'" class="important-link"><a href="#" @click.prevent="ssoClickNew('umr', 'mbrBenefits')" title="My Out-of-Pocket Spending">My Out-of-Pocket Spending</a></div>
                        <div v-if="showLinkButton('wellness-reward-program')" class="important-link"><a :href="'/wellness-rewards/'">Wellness Rewards Program</a></div>
                        <div v-if="showDODSsoButton()" class="important-link"><a title="" target="_blank" href="https://doctorondemand.com/microsite/compassrose/">Doctor On Demand™</a></div>
                        <div v-if="showIHSsoButton()" class="important-link"><a title="" target="_blank" href="https://includedhealth.com/microsite/compassrose/">Included Health</a></div>
                        <div v-if="showLinkButton('real-appeal-weight-loss')" class="important-link"><a href="https://www.compassrosebenefits.com/CRBG/Real_Appeal" title="Redirect to compassrosebenefits.com" target="_blank">Real Appeal® Weight Loss</a></div>
                        <div  v-if="showLivingWell()" class="important-link"><a href="https://www.compassrosebenefits.com/programs/living-well" title="Redirect to Living Well Program" target="_blank">Living Well Program</a></div>
                        <div v-if="healthplanD.provider == 'UHC'" class="important-link"><a href="https://retiree.uhc.com/compassrose" title="Redirect to Compass Rose Medicare Advantage" target="_blank">Compass Rose Medicare Advantage</a></div>
                        <div v-if="healthplanD.provider !== 'UHC'" class="important-link"><a href="https://www.labcorp.com/" title="Redirect to labcorp.com" target="_blank">LabCorp</a></div>
                        <div v-if="healthplanD.provider !== 'UHC'"  class="important-link"><a href="https://www.questdiagnostics.com/" title="Redirect to questdiagnostics.com" target="_blank">Quest Diagnostics</a></div>
                        <div v-if="healthplanD.provider !== 'UHC'" class="important-link"><a href="https://www.compassrosebenefits.com/CRBG/Tobacco_Cessation.aspx" title="Redirect to compassrosebenefits.com" target="_blank">Tobacco Cessation</a></div>
                        <div v-if="healthplanD.provider !== 'UHC'" class="important-link"><a href="https://www.activeandfitdirect.com/fitness/AF791520CO" title="Redirect to activeandfitdirect.com" target="_blank">Active&Fit Direct™</a></div>
                        <div v-if="healthplanD.provider !== 'UHC'" class="important-link"><a href="https://www1.careington.com/co/compass/" title="Redirect to careington.com" target="_blank">Dental & Vision Discount Program</a></div>
                        <div v-if="false && showLinkButton('sword-health')" class="important-link"><a href="#" @click.prevent="ssoClickNew('sword','')" title="Redirect to swordhealth.com">Sword Health</a></div>
                        <div v-if="false && showLinkButton('sword-health')" class="important-link"><a href="https://join.swordhealth.com/compassrose" title="Redirect to swordhealth.com" target="_blank">SWORD Health</a></div>
                        <div v-if="showLinkButton('bloom-digital-pelvic-health-care')" class="important-link"><a href="https://join.hibloom.com/compassrose" title="Bloom: Digital Pelvic-Health Care" target="_blank">Bloom: Digital Pelvic-Health Care</a></div>
                    </div>
                    <div v-else>
                        <div v-if="showwellnessrewards">
                            <div v-if="healthplanD.provider !== 'UHC'" class="important-link"><a :href="'/wellness-rewards/'">Wellness Rewards Program</a></div>
                        </div>
                        <div class="important-link"><a href="https://www.compassrosebenefits.com/CRBG/Doctor_On_Demand.aspx" title="Redirect to compassrosebenefits.com" target="_blank">Doctor On Demand™</a></div>
                        <div class="important-link"><a href="https://www.compassrosebenefits.com/CRBG/Real_Appeal" title="Redirect to compassrosebenefits.com" target="_blank">Real Appeal® Weight Loss</a></div>
                        <div class="important-link"><a href="https://www.labcorp.com/" title="Redirect to labcorp.com" target="_blank">LabCorp</a></div>
                        <div class="important-link"><a href="https://www.questdiagnostics.com/" title="Redirect to questdiagnostics.com" target="_blank">Quest Diagnostics</a></div>
                        <div v-if="healthplanD.provider !== 'UHC'" class="important-link"><a href="https://www.compassrosebenefits.com/CRBG/Tobacco_Cessation.aspx" title="Redirect to compassrosebenefits.com" target="_blank">Tobacco Cessation</a></div>
                        <div v-if="healthplanD.provider !== 'UHC'" class="important-link"><a href="https://www.activeandfitdirect.com/fitness/AF791520CO" title="Redirect to activeandfitdirect.com" target="_blank">Active&Fit Direct™</a></div>
                        <div v-if="healthplanD.provider !== 'UHC'" class="important-link"><a href="https://www1.careington.com/co/compass/" title="Redirect to careington.com" target="_blank">Dental & Vision Discount Program</a></div>
                        <div v-if="healthplanD.provider !== 'UHC' && showLinkButton('sword-health')" class="important-link"><a href="#" @click.prevent="ssoClickNew('sword','')" title="Redirect to swordhealth.com">Sword Health</a></div>
                        <div v-if="healthplanD.provider == 'UMR'" class="important-link"><a href="https://join.hibloom.com/compassrose" title="Bloom: Digital Pelvic-Health Care" target="_blank">Bloom: Digital Pelvic-Health Care</a></div>
                    </div>
                </div>
            </div>
        </div>
        <plan-contacts :contacts="healthplanD.hpc" :title="contactsTitle()"></plan-contacts>

        <div id="sso" v-html="sso" ref="sso"></div>
    </div>
</template>

<script>
import _ from "lodash";
import PlanContacts from "./PlanContacts";

export default {
    name: "PlanMedical",
    components: {PlanContacts},
    props: ['healthplanD', 'wellnessrewardssitecontentid', 'showwellnessrewards', 'userovereighteen', 'elig', 'ip', 'showbtns'],
    data() {
        return {
            userAgent: '',
            blockedFields: [],
            showMore: false,
            field: this.healthplanD.hpd_fields[0].children[0],
            sso: '',
            ssoData: '',
        }
    },
    mounted() {
        this.userAgent = navigator.userAgent;
    },
    computed: {
        chevronDirection() {
            return this.showMore ? 'fa-chevron-up' : 'fa-chevron-down';
        }
    },
    methods: {
        SsoButtonText(provider) {
            return this.$parent.ssoButtonText(provider);
        },
        showSub(sub) {
            if (sub.value !== '')
                return true;

            return !!sub.children.find(c => c.value !== '');
        },
        showSubfield(sub) {
            if (sub.value !== '')
                return true;

            return !!sub.children.find(c => this.showSub(c));
        },
        // ssoClickSword(provider, path) {
        //     document.getElementById("overlay").style.display = "flex";
        //     axios
        //         .get('/api/sso/' + provider + (path ? ('/' + path) : ''))
        //         .then(res => {
        //             this.sso = res.data.html;
        //         }).then(() => {
        //         // if(!this.isSafariIOS()){
        //         //     this.$refs.sso.children[3].target = '_blank';
        //         // }
        //         this.$refs.sso.children[3].submit();
        //         document.getElementById("overlay").style.display = "none";
        //     });
        // },
        // ssoClick(plan = '') {
        //     if(plan !== '') {
        //         plan = '/' + plan
        //     }
        //     document.getElementById("overlay").style.display = "flex";
        //     axios
        //         .get('/api/sso/' + this.healthplanD.provider.toLowerCase() + plan)
        //         .then(res => {
        //             this.sso = res.data.html;
        //         }).then(() => {
        //         // if(!this.isSafariIOS()){
        //         //     this.$refs.sso.children[3].target = '_blank';
        //         // }
        //         this.$refs.sso.children[3].submit();
        //         document.getElementById("overlay").style.display = "none";
        //     });
        // },
        ssoClickNew(provider, path = '') {
            const newPath = path ? `&path=${path}` : '';
            const baseUrl = `${window.location.origin}/dashboard`;
            window.open(`${baseUrl}?provider=${provider.toLowerCase()}${newPath}`, '_blank');
        },
        contactsTitle() {
            return this.healthplanD.planname + " Contact Information"
        },
        showLinkButton(button) {
            switch(button) {
                case 'wellness-reward-program':
                    return this.healthplanD.provider !== 'UHC' && this.healthplanD.groupnum !== '76411449- Standard';
                case 'sword-health':
                    return false;
                    // return this.healthplanD.provider !== 'UHC' && this.healthplanD.groupnum == '76411449- No Medicare';
                case 'real-appeal-weight-loss':
                    return this.healthplanD.groupnum !== '76411449- Standard';
                case 'bloom-digital-pelvic-health-care':
                    return false;
                    // return this.healthplanD.provider === 'UMR' && this.healthplanD.groupnum !== '76411449- Standard';
            }
        },
        ssoSPInitiateClicked(serviceProvider) {
            axios.post(`/api/cache-user-session`).then((res) => {
                if (res.status === 200) {
                    let url = null;

                    // for local test POST handle-authn-request
                    // url = `/sso-sp/initiate?service_provider=${serviceProvider}`;

                    if (serviceProvider === 'crbg-doctorsondemand') {
                        url = process.env.MIX_SSO_DOD_START_URL;
                    } else if (serviceProvider === 'crbg-includedhealth') {
                        url = process.env.MIX_SSO_IH_START_URL;
                    }

                    if (url) window.open(url, '_blank');
                }
            });
        },
        showDODSsoButton() {
            return this.userovereighteen === 1
                && (process.env.MIX_SHOW_SSO_DOD_IH_BUTTONS === 'true' || this.ip === process.env.MIX_VPN_IP)
                && (this.healthplanD.groupnum.includes('76411449- No Medicare')
                    || this.healthplanD.groupnum.includes('76411449- Standard'));
        },
        showIHSsoButton() {
            return this.userovereighteen === 1
                && (process.env.MIX_SHOW_SSO_DOD_IH_BUTTONS === 'true' || this.ip === process.env.MIX_VPN_IP)
                && (this.healthplanD.groupnum.includes('76411449- No Medicare'));
        },
        showLivingWell(){
            return this.healthplanD.groupnum.includes('76411449- No Medicare - 2024')
                || this.healthplanD.groupnum.includes('76411449- Standard');
        }
    }
}
</script>

<style scoped>

</style>
